module.exports = __webpack_public_path__ + "static/media/52.f92b58da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/52.svg
// module id = 172
// module chunks = 0